import type { UserAttributeDtoResponse } from './dto';
import type { UserAttribute } from './model/UserAttribute';
import { UserAttributeKind } from './model/UserAttribute';

const UserAttributeKindByStringDtoValue = {
  str: UserAttributeKind.String,
  email: UserAttributeKind.Email,
  bool: UserAttributeKind.Boolean,
  date: UserAttributeKind.Date,
  number: UserAttributeKind.Number,
  unknown: UserAttributeKind.Unknown,
};

export function mapDtoToModel(dto: UserAttributeDtoResponse): UserAttribute[] {
  return dto.attributes.map((item) => {
    return {
      created: item.created,
      datatype: UserAttributeKindByStringDtoValue[item.datatype],
      id: item.id,
      name: item.name,
      ruleType: item.rule_type,
      siteId: item.site_id,
      updated: item.updated,
    };
  });
}
